import React from "react";

import {
          getProduct,
          listProducts,
       } from 'graphql/queries'

import {
  createProduct,
  updateProduct,
  deleteProduct,
  createTeamMemberProduct,
  updateTeamMemberProduct,
} from 'graphql/mutations';

import {API} from '@aws-amplify/api'
import {Storage} from '@aws-amplify/storage'
import awsMobile from 'aws-exports';
import AWS from 'aws-sdk';
import {Actions as NOTIFICATIONACTIONS} from 'store/notifications/action';

// types of action
const Types = {
  PRODUCT_GET_ITEM: "PRODUCT_GET_ITEM",
  PRODUCT_UPDATE_ITEM: "PRODUCT_UPDATE_ITEM",
  PRODUCT_CREATE_ITEM: "PRODUCT_CREATE_ITEM",
  PRODUCT_DELETE_ITEM: "PRODUCT_DELETE_ITEM",
  PRODUCT_CLEAR_ITEM: "PRODUCT_CLEAR_ITEM",
  PRODUCT_LOADING: "PRODUCT_LOADING",
  PRODUCT_GET_LIST: "PRODUCT_GET_LIST",
  PRODUCT_UPDATE_PHOTO: "PRODUCT_UPDATE_PHOTO",
};

const dispatchLoading =  loading => ({
  type: Types.PRODUCT_LOADING,
  loading
});

const clearItem = response => ({
  type: Types.PRODUCT_CLEAR_ITEM
});

const dispatchGetItem = response => ({
  type: Types.PRODUCT_GET_ITEM,
  payload: response
});

const getItem = (id) => {
  console.log('getItem1',getItem)
  return (dispatch, getState) => {
    dispatch(dispatchLoading(true))

    const variables = {id}
    const request = API.graphql({query: getProduct, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})
    console.log('getItem2',getItem)
    request.then((response) => {
        dispatch(dispatchGetItem(response))
        dispatch(dispatchLoading(false))
    });
    
  }
}

const dispatchUpdateItem = response => ({
  type: Types.PRODUCT_UPDATE_ITEM,
  payload: response
});

const updateItem = (item) => {
  return (dispatch, getState) => {


    const state = getState()

    const photo = state.product.item.photo
    item.photo = photo

    const variables = {input: item}
    const request = API.graphql({query: updateProduct, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    request.then((response) => {
      console.log('responseTEST',response.data.updateProduct)
      
        dispatch(dispatchUpdateItem(response))

        //TODO Plan notification logic/errors
        dispatch(NOTIFICATIONACTIONS.addNotification({
          title: <React.Fragment><strong>{response.data.updateProduct.name}</strong> has been updated</React.Fragment>,
          message: response.data.updateProduct.enabled ? `Customers can book this product` : `This product is disabled. It cannot be booked`,
          icon: `success`,
        },
          3000
        ))
    });
    
  }
}

const dispatchDeleteItem = response => ({
  type: Types.PRODUCT_DELETE_ITEM,
  payload: response
});

const deleteItem = (id,_version,history) => {
  return (dispatch, getState) => {

    console.log('businessID',getState('businessID'))

    const businessID = getState().businessID
    const variables = {input: {id, _version }}
    const request = API.graphql({query: deleteProduct, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    request.then((response) => {
      console.log('responseTEST',response.data.deleteProduct)

        // go to main page as it's been deleted
        history.push(`/products`) 
        dispatch(dispatchDeleteItem(id))

        //TODO Plan notification logic/errors
        dispatch(NOTIFICATIONACTIONS.addNotification({
          title: <React.Fragment><strong>{response.data.deleteProduct.name}</strong> has been deleted</React.Fragment>,
          message: `This product is no longer available.`,
          icon: `success`,
        },2000))
    });
  }
}

const dispatchCreateItem = response => ({
  type: Types.PRODUCT_CREATE_ITEM,
  payload: response
});

const createItem = (item) => {
  return (dispatch, getState) => {

    console.log('businessID',getState('businessID'))

    const businessID = getState().businessID
    const variables = {input: {...item, businessID}}
    const request = API.graphql({query: createProduct, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    request.then((response) => {
      console.log('responseTEST',response.data.createProduct)

        dispatch(dispatchCreateItem(response))

        //TODO Plan notification logic/errors
        dispatch(NOTIFICATIONACTIONS.addNotification({
          title: <React.Fragment><strong>{response.data.createProduct.name}</strong> has been created</React.Fragment>,
          message: response.data.createProduct.enabled ? `You team can now start to provide this product.` : `This product is disabled and cannot be booked.`,
          icon: `success`,
        },2000))
    });
    
  }
}

const updateList = response => ({
  type: Types.PRODUCT_GET_LIST,
  payload: response
});

const getList = (limit, nextToken) => {
  return (dispatch, getState) => {

    const variables = {limit, nextToken}
    const request = API.graphql({query: listProducts, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    request.then((response) => {
        dispatch(updateList(response))
    });
    
  }
}

const updatePhoto = photo => ({
  type: Types.PRODUCT_UPDATE_PHOTO,
  photo
});

const handleUpload = (file, preFileName) => {
  return (dispatch, getState) => {

    const state = getState()

    const businessID = state.businessID

    console.log(file,'show me the file!')

    const {
      aws_user_files_s3_bucket_region: region,
      aws_user_files_s3_bucket: bucket
    } = awsMobile


    console.log(bucket,'this is the bucket!')

    const { name: fileName, type: mimeType } = file;

    const filePath = `product/${state.product.item.id}/${fileName}`  

    const key = preFileName ? preFileName : filePath

    const fileForUpload = {
      bucket,
      key,
      region,
      type: mimeType
    };

    dispatch(NOTIFICATIONACTIONS.addNotification({
      title: <React.Fragment><strong>Image</strong> is currently uploading. Please wait...</React.Fragment>,
      // message: response.data.updateLocation.status == "Active" ? `This location is raring and ready to go.` : `This location is disabled and cannot be booked.`,
      icon: `success`,
    },3000))


    const request = Storage.put(key, file, {
      level: 'public',
      contentType: mimeType,
      progressCallback: (e) => {
          console.log(e,'this is a callback! from storage')
      }
    });


    request.then(() => {

      dispatch(updatePhoto({
        key,
        bucket
      }))


      dispatch(NOTIFICATIONACTIONS.addNotification({
        title: <React.Fragment><strong>Photo</strong> has been uploaded</React.Fragment>,
        // message: response.data.updateLocation.status == "Active" ? `This location is raring and ready to go.` : `This location is disabled and cannot be booked.`,
        icon: `success`,
      },3000))

    });
  }
}


const Actions = {
  getItem,
  createItem,
  updateItem,
  deleteItem,
  getList,
  clearItem,
  handleUpload
}

// exports = {
//   Types,
//   Actions
// }

export {Types, Actions}

// exports.Types = Types
// exports.Actions = Actions